import styles from "../common/AlertCard.scss";
import SceUpdateToggle from "./SceUpdateToggle";
import classes from "./CustomerPreference.scss";
import { getLocalizedStrings } from "../centralizedLocalizedString";
import ReactHtmlParser from 'react-html-parser';
 
function SceUpdates(props) {
 
    let imageMail_On = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
    let imageMail_Off = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOff.svg';
    let warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    let strings = getLocalizedStrings("CustomerPreference");
    let checked = props.isMkgEnrolled;
    let imageMailOn = checked ? <img src={imageMail_On} alt="Mail Image On" /> : <img src={imageMail_Off} alt="Mail Image Off" />;
    let maskedEmailId = props.maskedMail;
    let cardDisplay = props.ErrorOnload || props.marketregrefresh;
    return (
        <div>
            {/* //error scenario */}
            { cardDisplay===true ?
            <div className={styles.AlertCards}>
                <div className={styles.AlertCardData}>
                    <p className={styles.AlertCardTitle}> {props.AlertName}</p>
                    <p className={styles.AlertCardSubtitle}> {ReactHtmlParser(props.staticContent.subTxt)}</p>                    
                    <div className={classes.errorMessage}>
                        <div className={classes.warningImg}> <img src={warningIcon} alt="Warning Icon" /></div>
                        {(props.marketregrefresh) ? <div className={classes.textAlignment}> <div>{strings.RegistrationError}</div> <a className={classes.refreshText} onClick={()=>props.handleMarket(!checked)}>{strings.RefreshText}</a></div> :
                        <div><div className={classes.textAlignment}>{strings.OnLoadError}<a className={classes.refreshText} onClick={props.handleMarkRefresh}>{strings.RefreshText}</a></div></div>}
                    </div>
                </div>
            </div>
            :
            <div className={styles.AlertCards}>
                <div className={styles.MainContainer}>
                    <div className={styles.LeftContainer}>
                        <div className={styles.AlertCardData}>
                            <p className={styles.AlertCardTitle}> {props.AlertName}</p>
                            <p className={styles.AlertCardSubtitle}>{ReactHtmlParser(props.staticContent.subTxt)}</p>
                            <div>
                                {(checked)?
                                <div className={styles.MailData}>
                                    <span> {imageMailOn}</span><span className={styles.MaskedMailData}>{maskedEmailId}</span>
                                </div>:null}
                            </div>
                        </div>
                    </div>
                    <div className={styles.DividerLine} />
                    <div className={styles.RightContainer}>
                        <div className={styles.SwitchAlign}>
                            <SceUpdateToggle isToggleOn={checked}{...props} />
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    );
}
export default SceUpdates;
